import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { useRouter } from "expo-router";

import UserAvatar from "@/Components/Media/User/Images/UserAvatar";
import type { AppUserSession } from "@/schemas/auth/session";

type Props = {
  session: AppUserSession;
};

const UserProfileHeader = ({ session }: Props): React.JSX.Element => {
  const router = useRouter();

  return (
    <View style={styles.headerContainer}>
      <TouchableOpacity
        style={styles.profileContainer}
        onPress={() => router.push("/(main)/account/home")}
        activeOpacity={0.7}
      >
        <UserAvatar
          avatar={session.identity.avatar}
          defaultAvatarColor={"black"}
          size={47}
          profilePress={{ username: session.identity.username }}
        />
        <View style={styles.profileTextContainer}>
          <Text style={styles.username}>@{session.identity.username}</Text>
          <Text style={styles.viewProfileText}>View your account</Text>
        </View>
        <Feather name="chevron-right" size={20} />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    padding: 8,
  },
  profileContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  profileTextContainer: {
    flex: 1,
    marginLeft: 12,
  },
  username: {
    fontSize: 20,
    fontWeight: "500",
  },
  viewProfileText: {
    fontSize: 16,
    marginTop: 2,
  },
});

export default UserProfileHeader;
